import React, { useEffect, Component } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { LoanProducts } from "@/components/LoanProducts";
import { EmiCalculator } from "@/components/EmiCalculator";
import { WhyUs } from "@/components/WhyUs";
import { Process } from "@/components/Process";
import { Faq } from "@/components/Faq";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { FloatingBar } from "@/components/FloatingBar";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(err) {
    console.error(err);
  }
  render() {
    if (this.state.hasError) return <div className="p-10 text-center">Kuch galat ho gaya. Page reload kijiye.</div>;
    return this.props.children;
  }
}

const App = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="bg-paper text-ink font-sans overflow-x-clip">
        <div className="grain" aria-hidden="true" />
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <LoanProducts />
          <EmiCalculator />
          <WhyUs />
          <Process />
          <Faq />
          <Contact />
        </main>
        <Footer />
        <FloatingBar />
      </div>
    </ErrorBoundary>
  );
};

export default App;
